import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { TechnicianLocationListResult, TechnicianLocationUpdateRequest } from '../models/technician-location.model';

@Injectable({ providedIn: 'root' })
export class TechnicianLocationService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiBaseUrl;

  updateLocation(technicianId: number, request: TechnicianLocationUpdateRequest): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/technicians/${technicianId}/location`, request);
  }

  getActiveTechnicianLocations(): Observable<TechnicianLocationListResult> {
    return this.http.get<TechnicianLocationListResult>(`${this.baseUrl}/technician-locations`);
  }
}
